import React, { Component } from 'react';
import './bar-chart.scss'; // Import the SCSS file

class BarChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Define the chart data
      labels: ['A', 'B', 'C', 'D', 'E', 'F'],
      data: [30, 20, 50, 40, 60, 70], // These are the heights of the bars
    };
  }



  adjustPercentagesInObjects(data, valueKey) {
    console.log(data)
    // Step 1: Round each value
    const roundedValues = data.map(item => ({
      ...item,
      rounded: Math.round(item[valueKey]), // Store rounded value
      fractionalPart: item[valueKey] - Math.floor(item[valueKey]), // Store fractional part
    }));

    // Step 2: Calculate the difference
    const total = roundedValues.reduce((sum, item) => sum + item.rounded, 0);
    const difference = 100 - total;

    console.log(difference)
    // Step 3: Adjust the values
    if (difference !== 0) {
      // Sort by fractional part (descending for adding, ascending for subtracting)
      const sorted = [...roundedValues].sort((a, b) =>
        difference > 0
          ? b.fractionalPart - a.fractionalPart // Descending for adding
          : a.fractionalPart - b.fractionalPart // Ascending for subtracting
      );

      console.log(sorted)

      // Apply the adjustment
      for (let i = 0; i < Math.abs(difference); i++) {
        if (sorted[i] && sorted[i].rounded) {
          sorted[i].rounded += difference > 0 ? 1 : -1;
        }

      }
    }

    // Step 4: Return adjusted data
    return roundedValues.map(item => ({
      ...item,
      [valueKey]: item.rounded, // Update original value with adjusted rounded value
    }));
  }




  renderBars() {
    const { labels, data } = this.state;
    const maxValue = Math.max(...data); // Find the maximum value to scale the chart properly


    let percentages = []

    console.log(this.props.studentResponseCount)

    this.props.options.forEach(item => {
      let percentage = (item.usersAnsweredCount / this.props.studentResponseCount) * 100
      percentages.push({ ...item, percentage })
    })

    console.log(percentages)

    let adjustedPercentagesData = this.adjustPercentagesInObjects(percentages, "percentage");


    return adjustedPercentagesData.map((option, index) => (
      <div className="bar" key={index}>
        <div
          className="bar-inner"
          style={{
            height: `${Math.round((option.usersAnsweredCount / this.props.studentResponseCount) * 100) - 5}%`,
            backgroundColor: option.isCorrect ? "#34B237" : "#FF6362", border: `1px solid ${option.isCorrect ? "#34B237" : "#FF6362"}`
          }} // Dynamically set height
        // style={{ height: `80%` }} // Dynamically set height
        >
          <div className="bar-percentage d-flex flex-column align-items-center justify-content-center">
            {
              option.usersAnsweredCount ? <div>{option.usersAnsweredCount}</div> : <div></div>
            }
            <div>{option.percentage}%</div>
          </div> {/* Show percentage */}
        </div>
        <span className="label" style={{ backgroundColor: option.isCorrect ? "#34B237" : "#FF6362", border: `1px solid ${option.isCorrect ? "rgb(52, 178, 51)" : "#FF6362"}` }}>{labels[index]}</span>
      </div>
    ));
  }

  render() {
    const { labels } = this.state;
    return (
      <div className='bar-wrapper'>
        {/* <div className='question-score-text text-center'>Responses by Options {`(${this.props.studentResponseCount} responses)`}</div> */}
        <div className='question-score-text d-flex justify-content-between'>
          <div className='question-score-text'>Responses by Options</div>
          <div className='d-flex'>
            <div className='d-flex align-items-center ml-3'><span className='indicator d-inline-block' style={{ background: "#34B237" }}></span><span className='indicator-text pl-3'>Correct</span></div>
            <div className='d-flex align-items-center ml-5 mr-3'><span className='d-inline-block indicator' style={{ background: '#FF6362' }}></span><span className='indicator-text pl-3'>Incorrect</span></div>
          </div>

        </div>
        <div className="chart-container">
          {/* <h2>Sales Data</h2> */}

          <div className="y-axis">
            {[100, 80, 60, 40, 20, 0].map((value) => (
              <div key={value} className="y-axis-label">{value}%</div>
            ))}
          </div>
          <div className="bar-chart">
            {this.renderBars()}
          </div>
          <div className='y-axis-header-1'>Response %</div>
          <div className='x-axis-header-1'>Options</div>
          {/* <div className="x-axis">
          {labels.map((label, index) => (
            <div key={index} className="label">{label}</div>
          ))}
        </div> */}
          {/* <div className="x-axis-label">Months</div>  */}
          {/* <div>Test</div> */}
        </div>
      </div>

    );
  }
}

export default BarChart;
